import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoutesRoutingModule } from './routes-routing.module';
import { SitesComponent } from './sites/sites.component';
import { SharedModule } from 'src/app/core/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { PlanningRouteListComponent } from './planning-route-list/planning-route-list.component';
import { PlanningFormComponent } from './planning-form/planning-form.component';
import { CompleteAddressComponent } from './components/complete-address/complete-address.component';
import { ConfirmRouteCreationComponent } from './planning-form/confirm-route-creation/confirm-route-creation.component';
import { AuthorizedSitesFormComponent } from './sites/authorized-sites-form/authorized-sites-form.component';
import { CityLocationFormComponent } from './planning-form/city-location-form/city-location-form.component';
import { RoutesMapComponent } from './routes-map/routes-map.component';
import { RoutePlanFormComponent } from './route-plan-form/route-plan-form.component';
import { CriticZonesComponent } from './critic-zones/critic-zones.component';
import { CriticZonesFormComponent } from './critic-zones/critic-zones-form/critic-zones-form.component';

@NgModule({
  declarations: [
    SitesComponent,
    PlanningRouteListComponent,
    PlanningFormComponent,
    CompleteAddressComponent,
    ConfirmRouteCreationComponent,
    AuthorizedSitesFormComponent,
    CityLocationFormComponent,
    RoutesMapComponent,
    RoutePlanFormComponent,
    CriticZonesComponent,
    CriticZonesFormComponent
  ],
  imports: [
    CommonModule,
    RoutesRoutingModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    DragDropModule,
    MatTableModule,
    MatSortModule,
    SharedModule.forRoot(),
  ],
  entryComponents: [
    ConfirmRouteCreationComponent,
    AuthorizedSitesFormComponent,
    CityLocationFormComponent,
    RoutePlanFormComponent,
    CriticZonesFormComponent
  ],
  bootstrap: [
    ConfirmRouteCreationComponent,
    AuthorizedSitesFormComponent,
    CityLocationFormComponent,
    RoutePlanFormComponent,
    CriticZonesFormComponent
  ]
})
export class RoutesModule { }
